export default __webpack_public_path__ + "static/media/border-bottom.66fa0b2a.svg";